import React, { Component } from 'react';
import { Button, message, Popconfirm, Table } from 'antd';
import { Link } from 'react-router';

import { queryCustomCompany, queryDeleteCustom } from '@api/crm/custom';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      total: 0,
      pageSize: 15,
      nowPage: 1,
    };
  }

  componentWillMount() {}

  componentDidMount() {
    this.getCustomCompany();
  }

  getCustomCompany = () => {
    const params = {};
    params.customerUuid = this.props.params.uuid;
    queryCustomCompany(params).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          data: res.data,
          total: res.data.totalCount,
          pageSize: res.data.pageSize,
          nowPage: res.data.pageNo,
        });
      }
    });
  };

  deleteCustom = uuid => {
    const context = this;
    const { nowPage, pageSize } = this.state;
    queryDeleteCustom(uuid).then(res => {
      if (res.statusCode === 200) {
        message.success('删除成功');
        context.getCustomCompany(nowPage, pageSize);
      } else {
        message.error(res.message);
      }
    });
  };

  columns = () => {
    return [
      {
        title: '公司名称',
        dataIndex: 'name',
        key: 'name',
        render: text => <span>{text}</span>,
      },
      {
        title: '客户类型',
        dataIndex: 'type',
        key: 'type',
        render: text => (text === 1 ? <span>公司</span> : <span>个人</span>),
      },
      {
        title: '公司官网',
        dataIndex: 'website',
        key: 'website',
        render: (text, record) => <span>{record.website}</span>,
      },
      {
        title: '行业类型',
        dataIndex: 'industry',
        key: 'industry',
        render: (text, record) => <span>{record.industry}</span>,
      },
      {
        title: '操作',
        key: 'done',
        render: (rext, record) => (
          <span>
            <Popconfirm
              onConfirm={() => this.deleteCustom(record.uuid)}
              title="确定删除当前组织吗？"
              placement="topRight"
              overlayStyle={{ width: 200 }}
            >
              <a className="ant-dropdown-link">删除</a>
            </Popconfirm>
          </span>
        ),
      },
    ];
  };

  render() {
    const { data } = this.state;
    const customerUuid = this.props.params.uuid;
    const { pageSize, total } = this.state;
    const pagination = {
      total,
      showSizeChanger: true,
      pageSize,
      onShowSizeChange: (current, size) => {
        this.getCustomCompany(current, size);
      },
      onChange: current => {
        this.getCustomCompany(current, pageSize);
      },
    };

    return (
      <div>
        <Link to={`/custom/base/${customerUuid}/company/add`}>
          <Button type="primary" icon="plus" style={{ marginBottom: 15 }}>
            添加
          </Button>
        </Link>
        <Table
          rowKey="uuid"
          style={{ background: '#fff' }}
          rowSelection={{}}
          columns={this.columns()}
          dataSource={data}
          pagination={pagination}
        />
      </div>
    );
  }
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/custom/base/company/Index.js